import { Base } from "./base";

export class Faq extends Base {
  /**C
   * @description Create FAQ API function
   * @returns {Promise<Response>}
   */


  create(payload) {
    const url = this._getFullURL("/faq");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
 
 

}
